import React, { useMemo } from 'react';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute';
import { NUMBER_UNIT_OPTIONS, NUMBER_PRECISION_OPTIONS } from '../../settings_sidebar/datasource/DatasourceSettingsRow.jsx';
import { cloneDeep } from 'lodash';
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';
import DashboardIconSelect from '../../../common/icon_select/DashboardIconSelect.lazy.jsx';
import styles from '../base/CommonSettings.module.scss';
import Select from '../../../common/Select.jsx';
import DashboardImageUploadButton from '../../../common/ImageUploader/DashboardImageUploadButton.lazy.jsx';
import FormatterOptions, { NUMBER_FORMAT_OPTIONS } from '../../settings_sidebar/ag_chart/components/FormatterOptions.jsx';
import FormulaFieldActions from '../../settings_sidebar/ag_chart/formula/FormulaFieldActions.jsx';
import { useChartColumnOptions } from '../../hooks/useChartColumnOptions.js';

function DataStripDatasetWidgetSettingsRow({d, index, widgetId, datasources}) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const updateDatasourceSetting = (key, index, value) => {
      const currentDatasources = cloneDeep(datasources);
      let datasource = {...datasources[index]};
      datasource[key] = value
      currentDatasources[index] = datasource;
      setAttribute('settings.datasources', currentDatasources);
    };
    // Effective datasource columns followed by the widget's formula fields
    const columnOptions = useChartColumnOptions(widgetId);
    const settingDatasourceOptions = useMemo(() => {
      return [{value: "", label: I18n.t("select_from_list")}, ...columnOptions]
    }, [columnOptions]);
    return (
        <div className={styles['settings-section']}>
          <label className={styles['settings-option']} style={{marginBottom: '4px'}}>
            {I18n.t("datasource")}
            <Select
              options={settingDatasourceOptions}
              value={d['colId']}
              placeholder={I18n.t("select_from_list")}
              onChange={(v) => updateDatasourceSetting("colId", index, v)}
            />
          </label>
          <FormulaFieldActions
            widgetId={widgetId}
            attr='colId'
            selectedObject={d}
            setAttribute={(key, v) => updateDatasourceSetting(key, index, v)}
          />
          <label className={styles['settings-option']}>
            {I18n.t("quantity")}
            <input type="text" className="form-control" name="quantity" data-index={index} placeholder={I18n.t("quantity_placeholder")} value={d.quantity} onChange={(e) => updateDatasourceSetting("quantity", e.target.dataset.index, e.target.value)} />
          </label>
          <label className={styles['settings-option']}>
            {I18n.t("unit")}
            <input type="text" className="form-control" name="unit" maxLength={30} data-index={index} value={d.unit} onChange={(e) => updateDatasourceSetting("unit", e.target.dataset.index, e.target.value)} />
          </label>
          <label className={styles['settings-option']}>
            {I18n.t("name_item")}
            <input type="text" className="form-control" name="name_item" maxLength={70} data-index={index} value={d.name_item} onChange={(e) => updateDatasourceSetting("name_item", e.target.dataset.index, e.target.value)} />
          </label>
          <label className={styles['settings-option']}>
            <div style={{ width: "20%", paddingLeft: "0", marginTop: "1rem", display: "inline-block" }}>{I18n.t("image")}</div>
            <DashboardIconSelect
              value={d.image}
              onChange={(v) => updateDatasourceSetting("image", index, v)}
            />
            <p className='description'>{I18n.t('predefined_image_primary_source_info')}</p>
          </label>
          <div className={styles['settings-option']}>
            <label style={{marginBottom: 0}}>{I18n.t('image_attachment')}</label>
            <DashboardImageUploadButton dialogMode={false} value={d.attachment} onChange={(val) => updateDatasourceSetting("attachment", index, val)} />
          </div>
          <label className={styles['settings-option']}>
            {I18n.t("background_color")}
            <ColorPicker value={d.background_color} onChange={(val) => updateDatasourceSetting("background_color", index, val)} />
          </label>
          <label className={styles['settings-option']}>
            {I18n.t("text_color")}
            <ColorPicker value={d.text_color} onChange={(val) => updateDatasourceSetting("text_color", index, val)} />
          </label>
          <FormatterOptions
            attr='formatter'
            label={I18n.t('number_formatter')}
            selectedObject={d}
            setAttribute={(key, v) => updateDatasourceSetting(key, index, v)}
            options={NUMBER_FORMAT_OPTIONS}
          />
          {/* The formatter supersedes unit & precision */}
          {!d.formatter && <>
            <label className={styles['settings-option']}>
              {I18n.t("number_unit")}
              <Select
                value={d.number_unit}
                onChange={(v) => updateDatasourceSetting("number_unit", index, v)}
                options={[{value: '', label: I18n.t("number_unit_none")}, ...NUMBER_UNIT_OPTIONS.map((o)=>({value: o, label: I18n.t(`number_unit_${o}`)}))]}
              />
            </label>
            <label className={styles['settings-option']}>
              {I18n.t("number_precision")}
              <Select
                value={d.number_precision === void 0 ? 2 : d.number_precision}
                onChange={(v) => updateDatasourceSetting("number_precision", index, v)}
                options={NUMBER_PRECISION_OPTIONS.map((o) => ({label: o, value: o}))}
              />
            </label>
          </>}
      </div>
    )
}

export default DataStripDatasetWidgetSettingsRow;
